"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfWorkQualificationResultDto = instanceOfWorkQualificationResultDto;
exports.WorkQualificationResultDtoFromJSON = WorkQualificationResultDtoFromJSON;
exports.WorkQualificationResultDtoFromJSONTyped = WorkQualificationResultDtoFromJSONTyped;
exports.WorkQualificationResultDtoToJSON = WorkQualificationResultDtoToJSON;
exports.WorkQualificationResultDtoToJSONTyped = WorkQualificationResultDtoToJSONTyped;
const ShiftCandidateResultDto_1 = require("./ShiftCandidateResultDto");
/**
 * Check if a given object implements the WorkQualificationResultDto interface.
 */
function instanceOfWorkQualificationResultDto(value) {
    if (!('results' in value) || value['results'] === undefined)
        return false;
    if (!('qualified' in value) || value['qualified'] === undefined)
        return false;
    if (!('unqualified' in value) || value['unqualified'] === undefined)
        return false;
    return true;
}
function WorkQualificationResultDtoFromJSON(json) {
    return WorkQualificationResultDtoFromJSONTyped(json, false);
}
function WorkQualificationResultDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'results': (json['results'].map(ShiftCandidateResultDto_1.ShiftCandidateResultDtoFromJSON)),
        'qualified': json['qualified'],
        'unqualified': json['unqualified'],
    };
}
function WorkQualificationResultDtoToJSON(json) {
    return WorkQualificationResultDtoToJSONTyped(json, false);
}
function WorkQualificationResultDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'results': (value['results'].map(ShiftCandidateResultDto_1.ShiftCandidateResultDtoToJSON)),
        'qualified': value['qualified'],
        'unqualified': value['unqualified'],
    };
}
//# sourceMappingURL=WorkQualificationResultDto.js.map